export default __webpack_public_path__ + "static/media/CNo.52-2.405c5040.jpg";